import type { StoryObj } from "@storybook/react";
import VideoCard from "../components/Cards/VideoCard";
import SideBySideText from "../components/Text/SideBySideText";
import Text from "../components/Text/Text";

const meta = {
    title: "Example/SideBySide",
    component: SideBySideText,
};

export default meta;
type Story = StoryObj<typeof meta>;

export const SBSVideoLeftTxt: Story = {};
export const SBSVideoRightTxt: Story = {
    args: {
        backgroundColor: "bg-blue",
        elementLeft: (
            <Text
                paragraphs={[
                    "Beim Beobachten von Energiefeldern entdeckte ich, dass unbewusste Eingriffe es verändern können. Die wahre Herausforderung liegt darin, zu beobachten, ohne zu beeinflussen. ",
                    "Selbst bei guter Wahrnehmung können voreilige Interpretationen von Energiefeldern zu Missverständnissen führen. Es ist essenziell, zu wissen, wann es bei der Beobachtung Zeit ist, Schlüsse zu ziehen, um die optimale Arbeit am Energiefeld zu gewährleisten.",
                ]}
                hasText={true}
                title={"Voraussetzung für eine Analyse"}
                titleSize="text-xl3 lg:text-5xl"
                paddings="px-3 lg:w-1/2"
                hasSubTitle={false}
                leading="leading-10 lg:leading-14"
                leadingText="leading-7 lg:leading-8.5"
            />
        ),
        elementRight: (
            <VideoCard
                title={"Beobachtung ohne interpretation"}
                textColor={"text-blue"}
                text={"beobachten ohne zu beeinflussen oder zu interpretieren gibt "}
                playPlacement="top-14 left-36 lg:top-44 lg:left-72"
                textPlacement="top-28 lg:top-72 lg:left-2"
            />
        ),
    },
};
export const SBSVideoLeftNoTxt: Story = {
    args: {
        hasText: false,
        title: "Warum gerade Fernbehandlung?",
        backgroundColor: "bg-yellow",
        imageTitle: "ES SIND ENERGIEFELDER, DIE NICHT STANDHALTEN",
        imageText: "ES IST NICHT DEINE SCHULD, WENN DU NICHT GENÜGEND stark bist.",
    },
};
export const SBSVideoRightNoTxt: Story = {
    args: {
        backgroundColor: "bg-blue",
        imageTitle: "voraussetzung für eine klare wahrnehmung",
        imageText: "wissen macht blind, wenn es um die wahrnehmung geht",
        imageTextColor: "text-blue",
        elementLeft: (
            <Text
                hasText={false}
                title={"Wissen macht blind, wenn es um die  Wahrnehmung geht"}
                titleSize="text-xl3 lg:text-5xl"
                paddings="px-3 lg:w-1/2"
                hasSubTitle={false}
            />
        ),
        elementRight: (
            <VideoCard
                title={"voraussetzung für eine klare wahrnehmung"}
                textColor={"text-blue"}
                text={"wissen macht blind, wenn es um die wahrnehmung geht"}
                playPlacement="top-14 left-36 lg:top-44 lg:left-72"
                textPlacement="top-28 lg:top-72 lg:left-2"
            />
        ),
    },
};
export const SBSVideoLeftNotxtSubTitle: Story = {
    args: {
        titleAlignment: "right",
        hasText: false,
        title: "Erkennen der Energiefelder",
        backgroundColor: "bg-white",
        imageTitle: "Rico Brunner",
        imageText: "Warum keine weiteren Informationen nötig sind",
        imageTextColor: "text-white",
        hasSubTitle: true,
        subTitle: "Auch wenn du weit weg bist",
    },
};
export const SBSTitleLeftTxtRight: Story = {
    args: {
        titleAlignment: "left",
        hasText: false,
        backgroundColor: "bg-turquoise",
        elementLeft: (
            <Text
                leading="leading-[52px] lg:leading-[80px]"
                titleSize="lg:text-[80px] text-[40px]"
                title="Energiefeld-mechanik"
                hasText={false}
                paddings="lg:px-20"
            />
        ),

        elementRight: (
            <Text
                title="Meine Forschungszukunft"
                titleSize="lg:text-5xl text-xl3 "
                leading="leading-10 lg:leading-14"
                paddings="lg:px-24 md:px-0"
                paragraphs={[
                    "Gerne teile ich mein Wissen mit anderen und habe mich daher dazu entschlossen, meine Forschungsarbeiten und Notizen in einer zugänglichen Form zu präsentieren. Möglicherweise können sie anderen in verschiedenen Fachgebieten bei ihren Forschungen nützlich sein und vielleicht ergeben sich sogar neue Forschungsbereiche, mit denen ich aktuell keine Berührungspunkte habe.",
                    "Ich habe noch so viele faszinierende Bereiche vor mir, die ich jetzt und in der Zukunft erforschen möchte, sodass dieses Leben leider nicht ausreichen wird. Aber das ist überhaupt nicht schlimm, denn jede bestätigte Erkenntnis bereichert meine Arbeit und ermöglicht es mir, Menschen noch effektiver zu unterstützen.",
                ]}
                leadingText="leading-7 lg:leading-8.5"
                hasReadMore={true}
                paragraphSlice={1}
            />
        ),
    },
};
